import React, { useEffect, useRef } from 'react';

import {
  displayElementAroundAnchor,
  getOppositeSide
} from 'utilities/element-position';

import './index.scss';

function ToolGroup(props) {

  const mainReference = useRef(null);

  useEffect(function onLoad() {

    positionToolGroup();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onSideAndLastScrolledAtChange() {

    positionToolGroup();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.toolbarDisplayedSide, props.lastScrolledAt]);

  function positionToolGroup() {

    const element = mainReference.current;
    const anchor = props.anchor.current;
    const viewport = document.body;
    const verticalOffset = 5;
    const horizontalOffset = 5;
    const startSide = props.toolbarDisplayedSide;
    const placeOnCenter = true;
    const positionableSides = [startSide, getOppositeSide(startSide)];

    displayElementAroundAnchor(element, anchor, viewport, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  function renderMain() {

    const mainAttributes = {
      className: 'tool-group-main',
      ref: mainReference
    };

    return <div {...mainAttributes}>
      {props.children}
    </div>;

  }

  return renderMain();

}

export default ToolGroup;